import { createBrowserRouter, RouterProvider, } from "react-router-dom";
import LoginPage from './Login/Login';
import ProtectedRoute from "./ProtectedRoute";
import DashboardPage from "./Dashboard/Index";
// import Index from "./Index/Index";
import StockAnalysis from "./Analysis/Index";
import Trading212Page from "./Trading212/Index";
import InstrumentsPage from "./Trading212/Instruments";

const router = createBrowserRouter([
    {
      path: "/",
      element: <LoginPage />,
    },
    {
      path: "/login",
      element: <LoginPage />,
    },
    {
      element: <ProtectedRoute />,
      children: [
      {
        path: "/dashboard",
        element: <DashboardPage />,
      },
      {
        path: "/stock-analysis",
        element: <StockAnalysis />,
      },
      {
        path: "trading212",
        element: <Trading212Page />,
      },
      {
        path: "trading212/instruments",
        element: <InstrumentsPage />,
      }
      ]
    }
]);

const AppRoutes = () => {
  return (
    <RouterProvider router={router}/>
  );
};

export default AppRoutes;